import React, { useContext, useEffect, useState } from "react";
import { Avatar, Button, Drawer, Dropdown, Layout, Menu } from "antd";
import trans, { isRTL } from "../../utils";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { webSocketManager } from "../../Sockets/WebSocketManager";
import { toast } from "react-toastify";
import Loader from "../Helpers/Loader/Loader";
import { filtrationcontext } from "../../context/Filtercontext";
import { popupcontext } from "../../context/Popupscontext";
import { languagecontext } from "../../context/LanguageContext";
import LiveEvents from "../LiveEvents/LiveEvents";
import LiveSubmittal from "../LiveEvents/LiveSubmittal";
import SideEvents from "../LiveEvents/SideEvents";
import { useGetNotificationsCountQuery } from "../../Redux/service/Notifications/NewNotifications";
import { useSelector } from "react-redux";
import { sidebarcontext } from "../../context/Sidebarcontext";
import LiveTasks from "../LiveEvents/LiveTasks";
import { socketIOManager } from "../../Sockets/SocketIOManager";
import { MergedKeyToRoute, MergedSidebar } from "../../utils/Sidebar/sidebar";
import DashboardNavigator from "../Dashboard/DashboardNavigator";
import "../../Styles/Mobile/MobileMainLayout.css";

const { Content } = Layout;

const MOBILE_BOTTOM_NAV_ITEMS = [
  //   { key: "menu", path: null, labelKey: "Menu", icon: "menu", isMenu: true },
  {
    key: "dashboard",
    path: "/dashboard",
    labelKey: "home",
    icon: "home",
  },
  {
    key: "ir",
    path: "/IR",
    labelKey: "IR",
    icon: "ir",
  },
  {
    key: "snag",
    path: "/snag-list",
    labelKey: "Snag",
    icon: "snag",
  },
  {
    key: "submittals",
    path: "/Submittals",
    labelKey: "Submittals",
    icon: "submittal",
  },
  {
    key: "report",
    path: "/snag-report",
    labelKey: "report",
    icon: "report",
  },
];

const MobileMainLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { loader, setLoader } = useContext(filtrationcontext);
  const { isFullScreen, setIsFullScreen, handleShow } =
    useContext(popupcontext);
  const { setLang } = useContext(languagecontext);
  const { setIsSideOpen } = useContext(sidebarcontext);
  const { data, refetch } = useGetNotificationsCountQuery();
  const inf = useSelector((state) => state.users.user);
  const auth = useSelector((state) => state.users.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboardRoute =
    location.pathname === "/" ||
    location.pathname === "/dashboard" ||
    location.pathname.startsWith("/dashboard/");

  useEffect(() => {
    if (inf?.id) {
      try {
        webSocketManager.connect();
        socketIOManager.connectMain(localStorage.getItem("token"));
        socketIOManager.connectTest(localStorage.getItem("token"));
      } catch (error) {
        toast.info(trans("Session Expired"), {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
        localStorage.removeItem("token");
        navigate("/signin");
      }
    }
  }, [navigate, inf?.id]);

  const routeToKey = Object.entries(MergedKeyToRoute).reduce(
    (acc, [key, path]) => {
      acc[path] = key;
      return acc;
    },
    {},
  );

  const basePermissionNames = Array.isArray(auth?.permissions)
    ? auth.permissions.map((perm) => perm?.name).filter(Boolean)
    : [];
  const permissionNames = [
    ...basePermissionNames,
    "setup.account",
    // Keep "Snag List" visible next to the gated "Snag Report" child (see sidebar.js):
    // an explicitly-matched sibling otherwise hides children that rely on the
    // parent's all-children fallback.
    ...(basePermissionNames.includes("snag") ? ["snag-list"] : []),
  ];

  const filteredItems = MergedSidebar?.map((item) => {
    const parentAllowed = permissionNames?.includes(item.key);
    if (item.children) {
      const allowedChildren = item.children?.filter((child) =>
        permissionNames?.includes(child.key),
      );
      if (parentAllowed) {
        return {
          ...item,
          children:
            allowedChildren?.length > 0 ? allowedChildren : item.children,
        };
      }
      if (allowedChildren?.length > 0) {
        return { ...item, children: allowedChildren };
      }
      return null;
    }
    return parentAllowed ? item : null;
  }).filter(Boolean);

  const currentKey = routeToKey[location.pathname];

  const goFullScreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleLogout = async () => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_AUTH_APIS_URL}/users/logout`,
        { withCredentials: true },
      );
      if (res.status >= 200 && res.status < 300) {
        webSocketManager.disconnect();
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("persist:root");
        sessionStorage.clear();
        delete axios.defaults.headers.common["Authorization"];
        window.location.replace(`${process.env.PUBLIC_URL}/signin`);
      }
    } catch (error) {
      console.warn("Logout failed:", error);
    }
  };

  const switchLanguage = (langKey) => {
    const currentLang = localStorage.getItem("lang");
    if (currentLang === langKey) return;
    setLoader(true);
    setLang(langKey);
    localStorage.setItem("lang", langKey);
    document.body.dir = langKey === "ar" ? "rtl" : "ltr";
    window.location.reload();
  };

  const avatarMenuItems = [
    {
      key: "lang",
      label: trans("Language"),
      children: [
        { key: "lang-ar", label: "العربية", onClick: () => switchLanguage("ar") },
        { key: "lang-en", label: "English", onClick: () => switchLanguage("en") },
      ],
    },
    {
      key: "settings",
      label: trans("Settings"),
      onClick: () => navigate("/setup/account"),
    },
    { type: "divider" },
    {
      key: "logout",
      label: trans("sign out"),
      danger: true,
      onClick: handleLogout,
    },
  ];

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, [setIsFullScreen]);

  const events = useSelector((state) => state.webSocket.events);
  useEffect(() => {
    if (events) refetch();
  }, [events, refetch]);

  const handleNavClick = (item) => {
    if (item.isMenu) {
      setDrawerOpen(true);
      return;
    }
    if (item.path) navigate(item.path);
  };

  const handleDrawerMenuClick = ({ key }) => {
    const path = MergedKeyToRoute[key];
    if (path) {
      navigate(path);
      setDrawerOpen(false);
    }
  };

  const isBottomNavActive = (item) => {
    if (item.isMenu) return false;
    if (item.key === "dashboard") {
      return (
        location.pathname === "/" ||
        location.pathname === "/dashboard" ||
        location.pathname.startsWith("/dashboard/")
      );
    }
    return (
      location.pathname === item.path ||
      location.pathname.startsWith(item.path + "/")
    );
  };

  if (loader) {
    return (
      <div className="loader-container">
        <div className="loader">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <Layout
      className="mobile-app-layout"
      dir={localStorage.getItem("lang") === "ar" ? "rtl" : "ltr"}
    >
      {/* Top bar */}
      <header className="mobile-app-header">
        <Button
          type="text"
          className="mobile-app-burger"
          aria-label="Menu"
          onClick={() => setDrawerOpen(true)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </svg>
        </Button>
        <div className="mobile-app-header-actions">
          {isDashboardRoute && (
            <div className="mobile-app-dashboard-nav">
              <DashboardNavigator />
            </div>
          )}
          <div
            className="mobile-app-notify position-relative"
            onClick={() => handleShow("notification")}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/dark/notifications.svg`}
              alt="notification"
            />
            {data?.count > 0 && (
              <span className="mobile-app-notify-badge">
                {data?.count > 99 ? "99+" : data?.count}
              </span>
            )}
          </div>
          <Dropdown
            menu={{ items: avatarMenuItems, triggerSubMenuAction: "click" }}
            trigger={["click"]}
            placement={isRTL ? "bottomLeft" : "bottomRight"}
          >
            <span className="mobile-app-user mobile-app-avatar-trigger">
              <Avatar
                style={{
                  backgroundColor: "rgba(255,255,255,0.3)",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                {inf?.name ? inf.name[0].toUpperCase() : "?"}
              </Avatar>
            </span>
          </Dropdown>
        </div>
      </header>

      {/* Main content */}
      <Content className="mobile-app-content">
        <LiveEvents />
        <LiveSubmittal />
        <LiveTasks />
        <SideEvents />
        <Outlet />
      </Content>

      {/* Bottom navigation */}
      <nav className="mobile-app-bottom-nav">
        {MOBILE_BOTTOM_NAV_ITEMS.map((item) => {
          const active = isBottomNavActive(item);
          return (
            <button
              key={item.key}
              type="button"
              className={`mobile-app-bottom-nav-item ${active ? "active" : ""}`}
              onClick={() => handleNavClick(item)}
              aria-current={active ? "page" : undefined}
            >
              {item.icon === "menu" ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                </svg>
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/mobile/${item.icon}${active ? "_green" : ""}.svg`}
                  alt=""
                />
              )}
              <span>{trans(item.labelKey)}</span>
            </button>
          );
        })}
      </nav>

      {/* Sidebar drawer */}
      <Drawer
        title={
          <div className="mobile-drawer-title">
            <img
              src={`${process.env.PUBLIC_URL}/assets/Lg-Logo.svg`}
              alt="Logo"
              style={{ width: 24, height: 24, marginInlineEnd: 8 }}
            />
            Soft Sprint
          </div>
        }
        placement={isRTL ? "right" : "left"}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        className="mobile-app-drawer"
        width="min(320px, 85vw)"
        styles={{ body: { padding: 0 } }}
      >
        <Menu
          mode="inline"
          selectedKeys={currentKey ? [currentKey] : []}
          items={filteredItems}
          onClick={handleDrawerMenuClick}
          style={{ border: "none", padding: "8px 0" }}
          className="mobile-app-drawer-menu"
        />
      </Drawer>
    </Layout>
  );
};

export default MobileMainLayout;
